import { mapActions, mapMutations } from 'vuex';
import api from '@/api';

export default {
  data() {
    return {
      displayEmailPrompt: false,
      sendingEmail: false,
      updatePatientEmail: false,
      validEmail: true,
    };
  },

  methods: {
    ...mapMutations(['showSnack']),

    ...mapActions('mailer', {
      sendEmail: 'create',
    }),

    sendStudy(study) {
      const { patient, _id } = study;
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!patient.email) {
        this.validEmail = 'Requerido';
        return;
      }

      if (!pattern.test(patient.email)) {
        this.validEmail = 'E-mail inválido';
        return;
      }

      const payload = { to: patient.email, studyId: _id };
      this.sendingEmail = true;

      this.sendEmail(payload)
        .then(() => {
          this.sendingEmail = false;
          this.displayEmailPrompt = false;
          this.showSnack('Estudio enviado');
        })
        .catch((e) => {
          this.sendingEmail = false;
          this.showSnack('Falló al enviar');
          throw e;
        });

      if (this.updatePatientEmail) {
        api.service('study').patch(_id, study);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/study-send.js